export default "__VITE_ASSET__Z6G9bQs2__"